import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MissionReportStateForm_MissionReport_ActionPermissions_QueryDocument =
  graphql(`
    query MissionReportStateForm_MissionReport_ActionPermissions_Query(
      $id: Id!
      $part: String!
    ) {
      findOneMission(id: $id) {
        access {
          actions(part: $part) {
            ...FolderBusinessEntityStateForm_ActionPermission_Fragment
          }
        }
      }
    }
  `);

export type MissionReportStateForm_MissionReport_ActionPermissions = ResultOf<
  typeof MissionReportStateForm_MissionReport_ActionPermissions_QueryDocument
>['findOneMission'];

// The actions of the state of a report info of the mission (its access part `report:<id>`).
export const useFindAllMissionReportInfoActionPermissionsQuery = (
  id = EMPTY_ID,
  reportInfoId = EMPTY_ID,
  enabled = !!id,
) =>
  useGraphQLQuery(
    MissionReportStateForm_MissionReport_ActionPermissions_QueryDocument,
    { id, part: `report:${reportInfoId}` },
    { enabled: !!id && !!reportInfoId && enabled },
  );
